<template>
  <div :id="anchorId" class="tw-w-full" :class="{ 'tw-mb-4': contentHeader }">
    <div
      class="tw-flex tw-justify-between lg:tw-space-x-4 lg:tw-space-y-0"
      :class="[customClass, { 'tw-space-y-4': !noContentMargin }]"
    >
      <div class="tw-w-full">
        <loading-title v-if="panelLoading" />
        <h4
          v-if="!panelLoading && text"
          class="tw-flex tw-text-h6 sm:tw-text-h5 lg:tw-text-h4 tw-leading-tight"
          :class="[
            !status && statusBgStyle,
            textAlign,
            { 'tw-font-medium': lowWeight },
          ]"
        >
          {{ text }}{{ status ? ': ' : '' }}
          <span v-if="status" class="tw-pl-1.5" :class="statusBgStyle">
            {{ status }}
          </span>

          <div
            v-if="$slots.tip"
            class="tw-flex tw-items-center sm:tw-items-end tw-flex-1 tw-justify-end"
          >
            <slot name="tip" />
          </div>
        </h4>

        <div
          v-if="$slots.content || $slots.noHtmlContent"
          class="tw-w-full"
          :class="[
            textAlign,
            {
              'tw-mb-6': !noContentMargin && basePanelHasContent,
              'tw-mt-2': !noContentMargin,
            },
          ]"
        >
          <loading-content v-if="panelLoading" hide-title />
          <div v-else class="mod-content">
            <p v-if="$slots.noHtmlContent">
              <slot name="noHtmlContent" />
            </p>
            <slot v-else name="content" />
          </div>
        </div>
      </div>

      <slot v-if="$slots.info && !$slots.tip" name="info" />

      <div
        v-if="$slots.buttons && !panelLoading"
        class="tw-flex tw-flex-col tw-justify-end tw-space-y-2"
      >
        <slot name="buttons" />
      </div>
    </div>
  </div>
</template>
<script>
import LoadingContent from '@components/Loading/LoadingContent.vue'
import LoadingTitle from '@components/Loading/LoadingTitle.vue'
import { getCurrentInstance, computed, toRefs } from 'vue'
export default {
  components: {
    LoadingTitle,
    LoadingContent,
  },
  props: {
    text: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: '',
    },
    contentHeader: {
      type: Boolean,
      default: false,
    },
    panelLoading: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: String,
      default: '',
    },
    anchorId: {
      type: String,
      default: undefined,
    },
    align: {
      type: String,
      default: 'left',
      validator: function (value) {
        return ['left', 'center', 'right'].indexOf(value) !== -1
      },
    },
    primary: {
      type: Boolean,
      default: false,
    },
    success: {
      type: Boolean,
      default: false,
    },
    danger: {
      type: Boolean,
      default: false,
    },
    warning: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Boolean,
      default: false,
    },
    lowWeight: {
      type: Boolean,
      default: false,
    },
    noContentMargin: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { align, primary, success, danger, warning, info } = toRefs(props)

    const textAlign = computed(() => {
      if (align.value === 'center') {
        return 'tw-justify-center tw-text-center'
      } else if (align.value === 'right') {
        return 'tw-justify-end tw-text-right'
      } else {
        return 'tw-justify-start tw-text-left'
      }
    })

    const statusBgStyle = computed(() => {
      if (success.value) {
        return 'tw-text-success'
      } else if (danger.value) {
        return 'tw-text-danger'
      } else if (warning.value) {
        return 'tw-text-warning'
      } else if (info.value) {
        return 'tw-text-info'
      } else if (primary.value) {
        return 'game-link-color'
      } else {
        return ''
      }
    })

    const basePanelHasContent = computed(() =>
      getCurrentInstance()?.parent?.slots?.default ? true : false
    )

    return {
      basePanelHasContent,
      statusBgStyle,
      textAlign,
    }
  },
}
</script>
